import VariantsIcon from '@material-ui/icons/LocalMallRounded';
import VariantsList from './VariantsList';
import VariantsEdit from './VariantsEdit';
import VariantsCreate from './VariantsCreate';
const VariantsModule = {
    list: VariantsList,
    icon: VariantsIcon,
    create: VariantsCreate,
    edit: VariantsEdit,
}; export default VariantsModule;